import { GroupService } from '../../Services/group.service';
import { Component, OnInit } from '@angular/core';
import Swal from 'sweetalert2';
import { AuthService } from '../../Services/auth.service';
import { MemberService } from '../../Services/member.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-member-list',
  template: require('./member-list.component.html'),
  styles: [require('./member-list.component.css')]
})
export class MemberListComponent implements OnInit {
  groups: any[] = [];
  loading: boolean = false;
  nameSearchString: string = '';
  searched_members: any[] = [];
  firstnames: any[] = [];
  lastnames: any[] = [];
  howOnlySelected: boolean = false;
  selected_members:any[] = [];
  hidden_members:any[] = [];

  checkNotPayed: boolean = false;
  checkNoDiscount: boolean = false;
  checkCategory: boolean = false;

  constructor(
        private router: Router, 
        private groupService: GroupService, 
        private auth: AuthService, 
        private memberService: MemberService) { }

  ngOnInit() {
    this.Refresh()
  }

  ngAfterViewInit() {
    // console.log('AfterView init');
    this.getAllGroups();
  }

  Refresh(){
    this.getAllGroups();
    this.getAllHiddenMembers()
  }

  getAllGroups(){
    this.loading = true;
    this.groupService.getGroups().subscribe( 
      g =>{
        this.groups = g;
        this.clearSearch();
        // console.log("groups in getAll groups");
        
        // console.log(this.groups);
        this.loading = false;
      }
    );
  }

  getAllHiddenMembers(){
    this.memberService.getAllHiddenMembers().subscribe ( (res:any)=>{
      if (res.status == 200){
        this.hidden_members = res.value
        
      }
      //console.log(this.hidden_members);
    })
  }


  clearSearch(){
    this.nameSearchString = '';
    this.searchName();
  }

  searchName(){
    if (this.nameSearchString.length > 0){
      // console.log(this.nameSearchString);

      this.checkNotPayed  = false;
      this.checkNoDiscount = false;
      this.checkCategory = false;

      this.firstnames.length = 0;
      this.lastnames.length = 0;
      this.groups.forEach(g => {


        let f = g.members.filter( (a:any) => a.firstName.toLowerCase().indexOf(this.nameSearchString.toLowerCase()) > -1) ;
        let l = g.members.filter( (a:any) => a.lastName.toLowerCase().indexOf(this.nameSearchString.toLowerCase()) > -1) ;

        if (f.length > 0) {
          this.firstnames.push({ id: g.id, name: g.name, members:f})
        }
        if (l.length > 0) {
          this.lastnames.push({ id: g.id, name: g.name, members:l})
        }
        
        
        
      });
      // console.log(this.firstnames);
      // console.log(this.lastnames);
      // this.firstnames = this.groups[0].members.filter( (a:any) => a.firstName.toLowerCase().indexOf(this.nameSearchString.toLowerCase()) > -1) ;
      // this.lastnames = this.members.filter( a => a.lastName.toLowerCase().indexOf(this.nameSearchString.toLowerCase()) > -1) ;
      this.searched_members = this.firstnames.concat(this.lastnames);
      // console.log(this.searched_members);
      
    }else{
      // this.searched_members = this.groups
      this.searched_members = [...this.groups];
    }
  }

  filterMembers(e:any){
    // console.log("fileterparameters: ");
    // console.log(e.target.checked);
    // console.log(e.target.value);
    // console.log(value);
    
    switch(e.target.value){
      case "noDiscount":{
        // console.log("checked no discount");       
        this.checkNotPayed  = false;
        this.checkNoDiscount = e.target.checked;
        this.checkCategory = false;
        
        this.searched_members.length = 0;
        if (e.target.checked){
            this.groups.forEach(g => {
            let c = g.members.filter( (a:any) => a.isExemptFromPayment == false );           
            if (c.length > 0){
              this.searched_members.push({ id: g.id, name: g.name, members:c});
            }
          });
        }else{
          this.searched_members = [...this.groups];
        }
        break;
      }
      case "notPayed":{
        // console.log("checked not payed");
        this.checkNotPayed  = e.target.checked;
        this.checkNoDiscount = false;
        this.checkCategory = false;
        
        this.searched_members.length = 0;
        if (e.target.checked){
          this.groups.forEach(g => {
          let c = g.members.filter( (a:any) => a.hasPayedMemberShip == false );           
          if (c.length > 0){
            this.searched_members.push({ id: g.id, name: g.name, members:c});
          }
        });
        }else{
          this.searched_members = [...this.groups];
        }

        break;
      }
      case "checkCategory":{
        // console.log("check category");
        this.checkNotPayed  = false;
        this.checkNoDiscount = false;
        this.checkCategory = e.target.checked;
        if (e.target.checked){
          Swal.fire({
            title: 'Welke categorie?',
            type: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Jep',
            cancelButtonText: 'Nope',
            input: 'number'
          }).then( (result) => {
            if (result.value) {
            this.searched_members.length = 0;
            
                this.groups.forEach(g => {
                let c = g.members.filter( (a:any) => a.memberDiscount.code == result.value );           
                if (c.length > 0){
                  this.searched_members.push({ id: g.id, name: g.name, members:c});
                }
              });
            }
          })
        }else{
          this.searched_members = [...this.groups];
        }
          break;
        }
    }    
  }

  DeleteForReal(Id: number){
    // console.log("Delete For real: ",Id );
    Swal.fire({
      title: 'Ben je zeker?',
      text: "Ben je zeker dat je deze user wil verwijderen, er is geen herstel meer mogelijk?",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Jep',
      cancelButtonText: 'Nope'
    }).then((result) => {
      if (result.value) {
        this.memberService.deleteReal(Id).subscribe ( (res:any)=>{
          // console.log("Delete for Real: ",res);
          if (res.status == 200){
            this.Refresh()
          }
        })       
      }
    });
  }
  

  Unhide(Id: number){
    Swal.fire({
      title: 'Ben je zeker?',
      text: "Ben je zeker dat je deze user terug zichtbaar wil maken?",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Jep',
      cancelButtonText: 'Nope'
    }).then((result) => {
      if (result.value) {
        this.memberService.unhideMember(Id).subscribe ( (res:any)=>{
          if (res.status == 200){
            this.Refresh()
          }
        })       
      }
    });
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/member-list/member-list.component.ts